import React from "react";

import Contact from "../Components/contact/Contact";
import Slider2 from "../Components/common/Slider2";
import Portfolios from "../Components/urunlerimiz/Urunlerimiz";
import Aboutus from "../Components/about/Aboutus";
import TopBar from "../Components/common/TopBar";

import useSEO from "../seo/useSEO";

function HomePage() {
  useSEO({
    title: "CNC Kayar Otomat ve Talaşlı İmalat Bursa | Aypin Otomat",

    description:
      "Aypin Otomat, Bursa Nilüfer'de CNC kayar otomat ve talaşlı imalat ile özel civata, pim, pirinç parça ve burç üretim çözümleri sunar.",

    path: "/",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
    ],
  });

  return (
    <>
      <TopBar />

      <Slider2 />

      {/* Ana sayfada H2 */}
      <Aboutus />

      {/* Ana sayfada H2 */}
      <Portfolios />

      {/* Ana sayfada H2 */}
      <Contact />
    </>
  );
}

export default HomePage;